import React from 'react';

import MyRoutes from './routes';

function App() {
  return (
    <MyRoutes />
  );
}

export default App;
